export const checkNegative = (number) => {
    if(number<0){
        return 0
    }else{
        return number
    }
};